module.exports = {
  id: 28,
  name: 'Upper Cuts',
  categories: ['strength', 'arms', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Strength',
  points: 11,
  instructions:
    'Upper Cuts make your arms super strong! Stand with your feet apart, make fists, then punch up toward the sky with both arms like a boxer!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to punch like a boxer? Let us build incredible arm strength!',
    },
    {
      time: 3,
      text: 'Stand with feet shoulder-width apart, make fists!',
    },
    {
      time: 6,
      text: 'Keep your core engaged and get ready to punch!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Bend your knees and rotate your hips!',
    },
    // SET 1 - 12 upper cuts
    {
      time: 12,
      text: 'Perfect boxing position! Feet shoulder-width apart, fists ready!',
    },
    {
      time: 15,
      text: 'Number 1! Bend your knees and rotate your hips!',
    },
    {
      time: 18,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 21,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 24,
      text: 'Number 2! Bend your knees and rotate your hips!',
    },
    {
      time: 27,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 30,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 33,
      text: 'Number 3! Bend your knees and rotate your hips!',
    },
    {
      time: 36,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 39,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 42,
      text: 'Number 4! Bend your knees and rotate your hips!',
    },
    {
      time: 45,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 48,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 51,
      text: 'Number 5! Bend your knees and rotate your hips!',
    },
    {
      time: 54,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 57,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 60,
      text: 'Number 6! Bend your knees and rotate your hips!',
    },
    {
      time: 63,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 66,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 69,
      text: 'Number 7! Bend your knees and rotate your hips!',
    },
    {
      time: 72,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 75,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 78,
      text: 'Number 8! Bend your knees and rotate your hips!',
    },
    {
      time: 81,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 84,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 87,
      text: 'Number 9! Bend your knees and rotate your hips!',
    },
    {
      time: 90,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 93,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 96,
      text: 'Number 10! Bend your knees and rotate your hips!',
    },
    {
      time: 99,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 102,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 105,
      text: 'Number 11! Bend your knees and rotate your hips!',
    },
    {
      time: 108,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 111,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 114,
      text: 'Number 12! Bend your knees and rotate your hips!',
    },
    {
      time: 117,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 120,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 123,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 126,
      text: 'Take a deep breath in and out, you are building incredible arm strength!',
    },
    {
      time: 129,
      text: 'Shake out your arms and hands, get ready for round two!',
    },
    {
      time: 132,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 135,
      text: 'Remember to bend your knees and rotate your hips!',
    },
    {
      time: 138,
      text: '3, 2, 1, START! Bend your knees and rotate your hips!',
    },
    // SET 2 - 12 upper cuts
    {
      time: 141,
      text: 'Perfect boxing position! Feet shoulder-width apart, fists ready!',
    },
    {
      time: 144,
      text: 'Number 1! Bend your knees and rotate your hips!',
    },
    {
      time: 147,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 150,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 153,
      text: 'Number 2! Bend your knees and rotate your hips!',
    },
    {
      time: 156,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 159,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 162,
      text: 'Number 3! Bend your knees and rotate your hips!',
    },
    {
      time: 165,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 168,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 171,
      text: 'Number 4! Bend your knees and rotate your hips!',
    },
    {
      time: 174,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 177,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 180,
      text: 'Number 5! Bend your knees and rotate your hips!',
    },
    {
      time: 183,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 186,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 189,
      text: 'Number 6! Bend your knees and rotate your hips!',
    },
    {
      time: 192,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 195,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 198,
      text: 'Number 7! Bend your knees and rotate your hips!',
    },
    {
      time: 201,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 204,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 207,
      text: 'Number 8! Bend your knees and rotate your hips!',
    },
    {
      time: 210,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 213,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 216,
      text: 'Number 9! Bend your knees and rotate your hips!',
    },
    {
      time: 219,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 222,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 225,
      text: 'Number 10! Bend your knees and rotate your hips!',
    },
    {
      time: 228,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 231,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 234,
      text: 'Number 11! Bend your knees and rotate your hips!',
    },
    {
      time: 237,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 240,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 243,
      text: 'Number 12! Bend your knees and rotate your hips!',
    },
    {
      time: 246,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 249,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 252,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 255,
      text: 'Take a deep breath in and out, you are building incredible arm strength!',
    },
    {
      time: 258,
      text: 'Shake out your arms and hands, get ready for round three!',
    },
    {
      time: 261,
      text: 'You are doing amazing! Ready for round three? Let us keep going!',
    },
    {
      time: 264,
      text: 'Remember to bend your knees and rotate your hips!',
    },
    {
      time: 267,
      text: '3, 2, 1, START! Bend your knees and rotate your hips!',
    },
    // SET 3 - 12 upper cuts
    {
      time: 270,
      text: 'Perfect boxing position! Feet shoulder-width apart, fists ready!',
    },
    {
      time: 273,
      text: 'Number 1! Bend your knees and rotate your hips!',
    },
    {
      time: 276,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 279,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 282,
      text: 'Number 2! Bend your knees and rotate your hips!',
    },
    {
      time: 285,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 288,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 291,
      text: 'Number 3! Bend your knees and rotate your hips!',
    },
    {
      time: 294,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 297,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 300,
      text: 'Number 4! Bend your knees and rotate your hips!',
    },
    {
      time: 303,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 306,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 309,
      text: 'Number 5! Bend your knees and rotate your hips!',
    },
    {
      time: 312,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 315,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 318,
      text: 'Number 6! Bend your knees and rotate your hips!',
    },
    {
      time: 321,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 324,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 327,
      text: 'Number 7! Bend your knees and rotate your hips!',
    },
    {
      time: 330,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 333,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 336,
      text: 'Number 8! Bend your knees and rotate your hips!',
    },
    {
      time: 339,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 342,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 345,
      text: 'Number 9! Bend your knees and rotate your hips!',
    },
    {
      time: 348,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 351,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 354,
      text: 'Number 10! Bend your knees and rotate your hips!',
    },
    {
      time: 357,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 360,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 363,
      text: 'Number 11! Bend your knees and rotate your hips!',
    },
    {
      time: 366,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 369,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 372,
      text: 'Number 12! Bend your knees and rotate your hips!',
    },
    {
      time: 375,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 378,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 381,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 384,
      text: 'Take a deep breath in and out, you are building incredible arm strength!',
    },
    {
      time: 387,
      text: 'Shake out your arms and hands, get ready for the final round!',
    },
    {
      time: 390,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 393,
      text: 'Remember to bend your knees and rotate your hips!',
    },
    {
      time: 396,
      text: '3, 2, 1, START! Bend your knees and rotate your hips!',
    },
    // SET 4 - 12 upper cuts
    {
      time: 399,
      text: 'Perfect boxing position! Feet shoulder-width apart, fists ready!',
    },
    {
      time: 402,
      text: 'Number 1! Bend your knees and rotate your hips!',
    },
    {
      time: 405,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 408,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 411,
      text: 'Number 2! Bend your knees and rotate your hips!',
    },
    {
      time: 414,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 417,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 420,
      text: 'Number 3! Bend your knees and rotate your hips!',
    },
    {
      time: 423,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 426,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 429,
      text: 'Number 4! Bend your knees and rotate your hips!',
    },
    {
      time: 432,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 435,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 438,
      text: 'Number 5! Bend your knees and rotate your hips!',
    },
    {
      time: 441,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 444,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 447,
      text: 'Number 6! Bend your knees and rotate your hips!',
    },
    {
      time: 450,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 453,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 456,
      text: 'Number 7! Bend your knees and rotate your hips!',
    },
    {
      time: 459,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 462,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 465,
      text: 'Number 8! Bend your knees and rotate your hips!',
    },
    {
      time: 468,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 471,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 474,
      text: 'Number 9! Bend your knees and rotate your hips!',
    },
    {
      time: 477,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 480,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 483,
      text: 'Number 10! Bend your knees and rotate your hips!',
    },
    {
      time: 486,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 489,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 492,
      text: 'Number 11! Bend your knees and rotate your hips!',
    },
    {
      time: 495,
      text: 'Punch up toward the sky with your right arm!',
    },
    {
      time: 498,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 501,
      text: 'Number 12! Bend your knees and rotate your hips!',
    },
    {
      time: 504,
      text: 'Punch up toward the sky with your left arm!',
    },
    {
      time: 507,
      text: 'Use your core and keep your balance!',
    },
    {
      time: 510,
      text: 'Incredible work! You just completed all four sets!',
    },
    // COMPLETION
    {
      time: 513,
      text: 'Amazing work! You did 48 upper cuts and built incredible arm strength!',
    },
    {
      time: 516,
      text: 'You are getting super strong and powerful! You are a boxing champion!',
    },
    {
      time: 519,
      text: 'Great job, strength champion! You are building incredible skills!',
    },
  ],
};
